import { render, staticRenderFns } from "./PhotovoltaicStation.vue?vue&type=template&id=52110e74&scoped=true"
import script from "./PhotovoltaicStation.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicStation.vue?vue&type=script&lang=js"
import style0 from "./PhotovoltaicStation.vue?vue&type=style&index=0&id=52110e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52110e74",
  null
  
)

export default component.exports